<!--
	Wrapper component: renderless. The script owns state, the template only exposes it
	through a scoped slot and renders no markup of its own. Twig owns every line of markup
	inside <star-rating …> (the hidden input the form posts, the stars, the value label) and
	binds to the slot props with v-slot="{ … }", ${ }, :value, :class, @click, @mouseover, and
	@mouseout. Inputs arrive as kebab-case attributes on the tag.
-->
<template>
	<slot v-bind="{ rating, hover, display, set, hoverOn, hoverOff }" />
</template>

<script setup>
import { computed, ref } from "vue";

const props = defineProps({
	// The form field name, e.g. "shippingTime"
	name: {
		type: String,
		required: true,
	},
	// The rating to start from, e.g. a value the form posted before a validation error
	initial: {
		type: Number,
		default: 0,
	},
	max: {
		type: Number,
		default: 5,
	},
});

const rating = ref(props.initial);
const hover = ref(0);

// The value the stars and label show: the hovered star wins over the chosen rating
const display = computed(() => hover.value || rating.value);

function set(value) {
	rating.value = Math.min(Math.max(value, 0), props.max);
}

function hoverOn(value) {
	hover.value = value;
}

function hoverOff() {
	hover.value = 0;
}
</script>
